var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    d: "M10 3c-3.857 0-7 3.143-7 7s3.143 7 7 7a6.957 6.957 0 0 0 4.946-2.054A6.957 6.957 0 0 0 17 10c0-3.857-3.143-7-7-7Zm3.982 10.982A5.599 5.599 0 0 1 10 15.625 5.624 5.624 0 0 1 4.375 10 5.624 5.624 0 0 1 10 4.375 5.624 5.624 0 0 1 15.625 10c0 1.5-.58 2.92-1.643 3.982Zm-3.268-8.125H9.286v4.679l3.625 2.214.75-1.214-2.947-1.804V5.857Z"
  })));
};
export default SvgClock;